export default __webpack_public_path__ + "img/Poppins-SemiBold_d58757b.ttf";